import React from "react";

const BackButton = props => (
  <svg className="cursor-pointer fill-current text-gray-300 hover:text-teal-500" width={13} height={20} {...props}>
    <path d="M.54 11.462l7.956 7.957a1.882 1.882 0 0 0 2.652 0l.664-.664a1.88 1.88 0 0 0 0-2.651l-6.07-6.072 6.07-6.072a1.88 1.88 0 0 0 0-2.65L11.15.644a1.88 1.88 0 0 0-2.652 0L.54 8.602a1.86 1.86 0 0 0-.537 1.43c-.03.514.145 1.039.536 1.43z" />
  </svg>
);

export default BackButton;
